import Checkbox from '@mui/material/Checkbox'
import CircularProgress from '@mui/material/CircularProgress'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'
import type { Dispatch, SetStateAction } from 'react'
import { FormattedMessage } from 'react-intl'

import { ColumnPickerSearch } from './ColumnPickerSearch'
import messages from './messages'
import * as S from './styles'
import type { ColumnCategory } from './useColumns'

interface ColumnPickerAvailableNodesProps {
  currentCategory: ColumnCategory
  selectedColumns: string[]
  query: string
  setQuery: Dispatch<SetStateAction<string>>
  onToggle: (column: string) => void
}

export const ColumnPickerAvailableNodes = ({
  currentCategory,
  selectedColumns,
  query,
  setQuery,
  onToggle,
}: ColumnPickerAvailableNodesProps) => {
  const areNodesLoading = currentCategory.availableNodes === undefined
  const areNodesEmpty = currentCategory.availableNodes?.length === 0
  const renderNodes = () => {
    if (areNodesLoading) {
      return (
        <S.LoadingContainer>
          <CircularProgress />
        </S.LoadingContainer>
      )
    }

    if (areNodesEmpty) {
      return (
        <Typography variant="body2" color="textSecondary">
          <FormattedMessage {...messages.noResultsFound} />
        </Typography>
      )
    }

    return currentCategory.availableNodes!.map((node) => (
      <S.AvailableNodeRow key={node.id}>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={selectedColumns.includes(node.id)}
              onChange={() => onToggle(node.id)}
              data-test-id="dynamic-column"
            />
          }
          label={
            <Typography
              variant="body2"
              color="textSecondary"
              noWrap
              data-test-id={`dynamic-column-name-${node.title}`}
            >
              {node.pickerTitle ?? node.title}
            </Typography>
          }
        />
      </S.AvailableNodeRow>
    ))
  }

  return (
    <>
      <S.SearchContainer data-test-id="search-container">
        <ColumnPickerSearch currentCategory={currentCategory} query={query} setQuery={setQuery} />
      </S.SearchContainer>
      <S.NodesList>{renderNodes()}</S.NodesList>
    </>
  )
}
